<template>

	<b-form-checkbox-group
	:options="displayOptions"
	stacked
	size="lg"
	/>

</template>

<script>
	export default {
		props:{
			"data":Object
		},
		computed:{
			displayOptions(){
				let options = this.data.settings.options;
				return options.map(o => {
					return {
						value: o,
						text: o
					}
				});
			},
			options(){
				return this.data.settings.options;
			}
		},
		data(){
			return {
				response: []
			}
		}
	}
</script>